import { isEmpty, once, pick } from 'lodash/fp';
import { getContext, take } from 'redux-saga/effects';

import { createReduxModule } from '@skippay/core/utils/reduxUtils';

import { USER_LOGGED_IN } from 'modules/auth/actions';

import { clearCjData, getCjData, setCjData } from './storage';

/**
 * Loads affiliate image. Guarded with `lodash.once` to run only once
 * @type {(userId: string) => void}
 */
const loadAffiliateImage = once((cjevent, userId) => {
	// this prefetch image as if is displayed on page
	new Image().src =
		process.env.NODE_ENV === 'production'
			? `https://www.kdukvh.com/u?CID=1556358&OID=${userId}&TYPE=435287&AMOUNT=0&CURRENCY=CZK&METHOD=IMG&CJEVENT=${cjevent}`
			: `http://localhost/malformedAffiliateImgUrl?userId=${userId}&cjevent=${cjevent}`;
});

function* sagaInit() {
	const history = yield getContext('history');
	const cjData = pick(['AID', 'PID', 'SID', 'cjevent'], history.location.query);
	if (!isEmpty(cjData)) {
		setCjData(cjData);
	}
	const cjEvent = getCjData()?.cjevent;

	if (cjEvent) {
		// user arrived from affiliate program, wait for first login
		const {
			payload: { user },
		} = yield take(USER_LOGGED_IN);

		// load affiliate pixel
		loadAffiliateImage(cjEvent, user.id);
		// and remove cjEvent thus pixel wont be loaded next time
		clearCjData();
	}
}

export default createReduxModule('affiliate', null, [sagaInit]);
